<script setup lang="ts">
import { watch } from 'vue'

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"
import { useViewStore } from '@/stores/viewStore'
import { get_data_attr, sortDropdownOptions } from '@/utils/globals'

const viewStore = useViewStore();

const items = sortDropdownOptions([
  { value: -1, label: "Kein Kunde" },
  ...get_data_attr("customers")
])

watch(
  () => viewStore.currentCustomer,
  (newVal, oldVal) => {
    if (newVal === -1) {
      // Force select option 10
      viewStore.currentCustomer = 10;
      return; // Stop redirect
    }

    // Normal redirect
    window.location.href = '?session_id=-1&customer_id=' + newVal;
  }
);
</script>

<template>
  <div class="hoeppner-bg-white h-10">
    <Select v-model="viewStore.currentCustomer">
      <SelectTrigger>
        <SelectValue placeholder="Kunde..." />
      </SelectTrigger>
      <SelectContent class="z-[10002]">
        <SelectGroup>
          <SelectLabel>Kunde Selektion</SelectLabel>
          <SelectItem
            v-for="item in items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
</template>
